import { Reducer } from '@reduxjs/toolkit'

import { loggedin, requestProfile } from '@/store/profile'

import { RECEIVE_PRODUCT_BUNDLE, REMOVE_PRODUCT_BUNDLE, REQUEST_PRODUCT_BUNDLE } from '../actions/product-bundles'
import { removeItemsById, updateOrAddItemsById } from '../helpers'

const initialState = {
    isFetching: null,
    fetchSuccessful: null,
    items: [],
}

// @TODO: Replace `any` with ProductBundleSlice model once it's defined
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const productBundlesReducer: Reducer<any> = (currentState, { type, data, payload }) => {
    const state = currentState ?? initialState

    switch (type) {
        case REQUEST_PRODUCT_BUNDLE: {
            return { ...state, isFetching: true }
        }

        case RECEIVE_PRODUCT_BUNDLE: {
            const { item, fetchSuccessful } = data

            const items = updateOrAddItemsById({ currentItems: state.items, receivedItems: [item] })

            return {
                ...state,
                items,
                fetchSuccessful,
                isFetching: false,
            }
        }

        case REMOVE_PRODUCT_BUNDLE: {
            const items = removeItemsById({ currentItems: state.items, id: data.id })
            return { ...state, items, isFetching: false }
        }

        case loggedin.fulfilled.toString():
        case requestProfile.fulfilled.toString(): {
            const receivedItems = payload?.profile?.productBundles || []
            return {
                ...state,
                items: updateOrAddItemsById({ currentItems: state.items, receivedItems }),
            }
        }

        default:
            return state
    }
}

export default productBundlesReducer
